import { mapLanguageToProps } from 'i18n'
import ar from 'interview/i18n/ar'
import da from 'interview/i18n/da'
import en from 'interview/i18n/en'
import fi from 'interview/i18n/fi'
import no from 'interview/i18n/no'
import se from 'interview/i18n/se'
import de from 'interview/i18n/de'
import it from 'interview/i18n/it'
import es from 'interview/i18n/es'
import nl from 'interview/i18n/nl'
import fr from 'interview/i18n/fr'
import pl from 'interview/i18n/pl'
import el from 'interview/i18n/el'
import ro from 'interview/i18n/ro'
import bg from 'interview/i18n/bg'
import hu from 'interview/i18n/hu'
import uk from 'interview/i18n/uk'
import cs from 'interview/i18n/cs'
import hr from 'interview/i18n/hr'
import sk from 'interview/i18n/sk'
import sl from 'interview/i18n/sl'
import sr from 'interview/i18n/sr'
import ru from 'interview/i18n/ru'
import et from 'interview/i18n/et'
import zh from 'interview/i18n/zh'
import pt from 'interview/i18n/pt'
import ja from 'interview/i18n/ja'
import tr from 'interview/i18n/tr'
import ko from 'interview/i18n/ko'
import zhTW from 'interview/i18n/zh-tw'


export const languages = { ar, da, de, en, fi, no, se, it, es, nl, fr, pl, el, ro, bg, hu, uk, cs, hr, sk, sl, sr, ru, et, zh, pt, ja, tr, ko, 'zh-tw': zhTW }

export function mapLanguageToComponentProps(map) {
  return mapLanguageToProps(languages, 'component', map)
}

export function mapLanguageToPageProps(map) {
  return mapLanguageToProps(languages, 'page', map)
}
